import {
  ShoppingBag, Factory, HardHat, CircleDollarSign,
  Building2, Plane, Shirt, BadgeCheck,
} from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionLabel from "@/components/SectionLabel";
import { INDUSTRIES } from "@/data/site";

const ICONS = { ShoppingBag, Factory, HardHat, CircleDollarSign, Building2, Plane, Shirt, BadgeCheck };

export default function Industries({ index = "/01" }) {
  return (
    <section data-testid="industries-section" className="py-24 md:py-32 border-t border-zinc-200">
      <div className="container-tight">
        <div className="grid md:grid-cols-12 gap-8 mb-14 items-end">
          <Reveal className="md:col-span-7">
            <SectionLabel index={index} testid="industries-label">Industries we serve</SectionLabel>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl text-zinc-900 tracking-tighter leading-[1.02]">
              Depth across
              <br /><span className="text-zinc-400">eight verticals.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5">
            <p className="text-zinc-600 leading-relaxed md:text-right">
              Five years of compounded delivery experience — across regulated and consumer
              markets, India and the Gulf. The patterns we&apos;ve seen in one industry
              accelerate the next.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-200 border border-zinc-200">
          {INDUSTRIES.map((ind, idx) => {
            const Icon = ICONS[ind.icon];
            return (
              <Reveal key={ind.name} delay={idx * 0.04}>
                <div
                  data-testid={`industry-${ind.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="bg-[#FAFAF7] p-6 lg:p-8 h-full group hover:bg-white transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-mono-tech text-xs text-zinc-500">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    {Icon && (
                      <Icon className="w-5 h-5 text-zinc-500 group-hover:text-zinc-900 transition-colors" />
                    )}
                  </div>
                  <h3 className="mt-8 font-display text-xl text-zinc-900 tracking-tight">
                    {ind.name}
                  </h3>
                  <p className="mt-2 text-zinc-500 text-[13px] leading-relaxed">{ind.note}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
